import { GetParam } from "utils/tools";
import {
  EditProps,
  maxValue,
  minValue,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
  Toolbar,
  useEditController,
} from "react-admin";
import moment from "moment/moment";
import { Grid, Typography } from "@material-ui/core";
import CustomDateRangeInput from "../../components/CustomDateRangeInput";
import SanitizedGrid from "../../components/SanitizedGrid";
import SaveButtonStudentSubsidy from "./components/SaveButtonStudentSubsidy";
import EditWrapper from "../../components/EditWrapper";
import PermissionLoading from "../../components/PermissionLoading";
import React from "react";

const StudentSubsidyEdit = (props: EditProps) => {
  const param = GetParam();
  const { record, loading } = useEditController(props);

  let breadcrumbValue = [{ link: "", title: "", params: "" }];

  if (param.get("parentId")) {
    breadcrumbValue = [
      {
        title: "Parents",
        link: `/parents/${param.get("parentId")}/show`,
        params: "",
      },
      {
        title: "Students",
        link: `/students/${param.get("studentId")}/show`,
        params: `?parentId=${param.get("parentId")}`,
      },
      {
        title: "Payment Setting",
        link: `/students/${param.get("studentId")}/show/6`,
        params: `?parentId=${param.get("parentId")}`,
      },
      {
        title: "Edit",
        link: "",
        params: "",
      },
    ];
  } else {
    breadcrumbValue = [
      {
        title: "Students",
        link: `/students/${param.get("studentId")}/show`,
        params: "",
      },
      {
        title: "Payment Setting",
        link: `/students/${param.get("studentId")}/show/6`,
        params: "",
      },
      {
        title: "Edit",
        link: "",
        params: "",
      },
    ];
  }

  const breadcrumb = breadcrumbValue;

  const formatRecord = (res: any) => {
    if (res) {
      if (res.periodStartDate) {
        res.periodStartDate = moment(res.periodStartDate).format("YYYY-MM-DD");
      }

      if (res.periodEndDate) {
        res.periodEndDate = moment(res.periodEndDate).format("YYYY-MM-DD");
      }

      return res;
    }
  };

  const CustomToolbar = (props: any) => {
    return (
      <Toolbar {...props}>
        <SaveButtonStudentSubsidy formInvalid={props.invalid} />
      </Toolbar>
    );
  };

  if (loading) {
    return <PermissionLoading />;
  }

  return (
    <>
      <EditWrapper
        breadcrumb={breadcrumb}
        customNameWithId="Student Subsidy"
        actions={null}
        {...props}
      >
        <SimpleForm record={formatRecord(record)} toolbar={<CustomToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Student</Typography>
            </Grid>
            <Grid item xs={3}>
              <ReferenceInput
                label="Select Student"
                source="studentId"
                reference="students"
                disabled
              >
                <SelectInput
                  optionText={(choice: any) =>
                    `${choice.firstName} ${choice.lastName}`
                  }
                />
              </ReferenceInput>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Subsidy Details</Typography>
            </Grid>

            <Grid item xs={12}>
              <CustomDateRangeInput
                fromSource="periodStartDate"
                toSource="periodEndDate"
                fromLabel="Period Start Date"
                toLabel="Period End Date"
                gridItemWidth={2}
              />
            </Grid>

            <Grid item xs={4}>
              <NumberInput
                source="subsidyPercentage"
                label="Subsidy Percentage (%)"
                validate={[required(), minValue(0), maxValue(100)]}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput
                multiline={true}
                label="Remark"
                source="remark"
              />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </EditWrapper>
    </>
  );
};

export default StudentSubsidyEdit;
